import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background text-foreground">
          <div className="text-center space-y-4 px-6">
            <h1 className="text-lg font-mono">Something went wrong</h1>
            <p className="text-sm text-muted-foreground">An unexpected error occurred.</p>
            <button
              onClick={() => {
                this.setState({ hasError: false });
                window.location.href = '/';
              }}
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Return home
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
